import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { MultiStyleType } from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const onboardingParts = [
  'content',
  'features',
  'welcomeText',
  'list',
  'bodyText',
  'button',
  'image',
] as const

const helpers = createMultiStyleConfigHelpers(onboardingParts)

export const OnboardingStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    content: {
      display: 'flex',
      padding: '3.75rem',
      flexDirection: 'column',
      alignItems: 'center',
    },
    features: {
      maxWidth: '33.5rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1.25rem',
      alignSelf: 'stretch',
      paddingBottom: '1rem',
    },
    welcomeText: {
      textAlign: 'center',
      fontSize: '1.5rem',
      fontWeight: '700',
    },
    bodyText: {
      textAlign: 'center',
      fontSize: '0.875rem',
      fontWeight: '400',
    },
    button: {
      width: 'fit-content',
    },
    image: {
      maxWidth: '32.75rem',
      height: 'auto',
    },
  },
  defaultProps: {},
})

export const useOnboardingStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(OnboardingStyle, props) as MultiStyleType<
    typeof onboardingParts
  >
}
